import appModeController from '@/scripts/appModeController'

const ua = navigator.userAgent.toLowerCase()

// ---- Platform fixes ----

// Real iPad detection (works even when UA spoofs "Macintosh")
export const isIPad = /ipad/.test(ua) || (navigator.maxTouchPoints > 1 && /macintosh/.test(ua))

export const isIOS = /iphone|ipod/.test(ua) || isIPad

export const isAndroid = ua.includes('android')

// Touch-capable device?
export const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0

// Pointer type
const pointerCoarse = matchMedia('(pointer: coarse)').matches
const pointerFine = matchMedia('(pointer: fine)').matches

// Small screens typically = phones
const isSmallScreen = Math.min(window.innerWidth, window.innerHeight) < 768

// ---- Classification ----

// KEEPING YOUR ORIGINAL FLAG — but fixed
export const isMobile = (isIOS || isAndroid) && pointerCoarse && isSmallScreen

export const isTablet = isIPad || (isAndroid && pointerCoarse && !isSmallScreen)

export const isMobileOrTablet = isMobile || isTablet

// Desktop-like = devices that behave as desktop
export const isDesktopLike =
  !isMobileOrTablet && pointerFine && (ua.includes('windows') || ua.includes('macintosh') || ua.includes('linux'))

export const isPhone = isMobile

export const isDesktopCapable = !isPhone

export const isDesktopMode = (): boolean => {
  return appModeController.getCurrentMode() === 'desktop'
}
